//Angular
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
//App
import { AppAnimations } from 'src/app/_shared/animations';
import { ApiKeyStatus, VisibleState, responseCode } from 'src/app/app.data';
import { ApiKeysModel } from 'src/app/_shared/models/api-keys.model';
import { RestResponse } from 'src/app/_shared/models';
import { SettingsService } from '../../_services/api/settings.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import { MetaService } from 'src/app/_core/services/meta.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmationComponent } from '../../../_shared/dialog/confirmation/confirmation.component';
import { KeyName } from 'src/app/app.keynames';
import { LoaderService } from 'src/app/_core/services';

@Component({
  animations: [AppAnimations],
  selector: 'app-api-credentials',
  templateUrl: './api-credentials.component.html'
})

export class ApiCredentialsComponent implements OnInit, OnDestroy {
  apiKey: string;
  collectionOfApiKeys: Array<ApiKeysModel> = [];
  isReadyApiKeys: boolean = false;
  statusForGridMessage: VisibleState = VisibleState.isHidden;
  statusForRestResponse: VisibleState = VisibleState.isHidden;
  private subs = new Unsubscriber();

  @Input() _apiKeyStatus = ApiKeyStatus;
  @Input() _visibleState = VisibleState;
  dataSource!: any[];

  config = {
    cols: [
      {
        name: 'Url',
        key: 'url',
      },
      {
        name: 'Trigger',
        key: 'triggers',
        cellTemplate: 'triggerstemplate'
      },

      {
        name: 'Actions',
        key: 'action',
        cellTemplate: 'actiontemplate'
      }
    ]
  }
  triggers: any[]= [];
  constructor(
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private settingsService: SettingsService,
    private _meta: MetaService,
    private _dialog: MatDialog,
    private loader: LoaderService
  ) {
    this._iconRegistry.addSvgIcon('ico-actions', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-actions-01.svg'));
    this._iconRegistry.addSvgIcon('ico-copy', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-copy-01.svg'));
    this._iconRegistry.addSvgIcon('ico-close-menu', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-03.svg'));
    this._iconRegistry.addSvgIcon('ico-edit', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-edit-02.svg'));

  }

  getApiKeys() {
    this.subs.addSub = this.settingsService.getApiKeys(true).subscribe(
      (res:RestResponse) => {
        this.collectionOfApiKeys = <Array<ApiKeysModel>>res.data;
        if (this.collectionOfApiKeys.length > 0){
          this.apiKey = this.collectionOfApiKeys[0].apiToken;
          this.statusForRestResponse = VisibleState.isVisible;
          this.statusForGridMessage = VisibleState.isHidden;
        } else {
          this.statusForRestResponse = VisibleState.isHidden;
          this.statusForGridMessage = VisibleState.isVisible;
        }
        this.isReadyApiKeys = true;
      },
      (err:RestResponse) => {
        this.isReadyApiKeys = true;
        this.statusForRestResponse = VisibleState.isHidden;
        this.statusForGridMessage = VisibleState.isVisible;
        console.log('@@@',err);
      }
    )
  }

  ngOnInit(): void {
    setTimeout(() => { this.getApiKeys(); }, 2000);
    this.getWebhookList();
    this.getTriggers();
  }

  getTriggers(){
    this.settingsService.getWebhookTriggers().subscribe(res => {
      this.triggers = res.data;
    })
  }

  testCompanyWebhookTriggers(webhookId: any, id: any){
    this.settingsService.testCompanyWebhookTrigger(webhookId, id).subscribe(res=>{
      if(res.data?.responseBody?.status == '400') {
        this._meta.showNotificationCustomMessage(responseCode.errorServerCode, '', res.data?.responseBody?.message, null);
      } else {
        this._meta.showNotification(res);
      }
    })
  }

  testTrigger(trigger){
    this.settingsService.testRblTrigger(trigger.id).subscribe(res => {
      if(res.data.code === 'webhook_api_call_error') {
        this._meta.showNotificationCustomMessage(responseCode.errorServerCode, '', 'There was an error calling the api to current configuration', null);
      } else {
        this._meta.showNotification(res);
      }
    })
  }

  delete(data) {
    const dialogConfirmation = this._dialog.open(DialogConfirmationComponent, {
      panelClass: ['custom-mat-dialog'],
      data: {
        keyName: KeyName.delete_webhook,
        webhook:data
      },
    });
    dialogConfirmation.afterClosed().subscribe((resCode) => {
      if (resCode === KeyName.delete_webhook) {
      this.settingsService.deleteWebhook(data.id).subscribe((res)=>{
        this.getWebhookList();
        this._meta.showNotification(res);
      },
      ((error)=>{
        this._meta.showNotification(error);
      })
      );
      this.loader.stopPageLoader();
      }
    });
  }
  getWebhookList(): void {
    this.settingsService.getWebhooks().subscribe((res)=>{
      this.dataSource = res.data;
    },()=>{
      this.dataSource = [];
    });
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
